import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner, TextField } from '@shopify/polaris';
import { cross } from '../../../assets';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getAppOverViewDetails, saveconfigurationsApi, submitAppApi } from '../../dev_services/developer/api';
import { fetchDataSuccess } from '../../dev_store/slice/apps_overview_slice/apps_overview_slice';
import { Modal } from '@mui/material';
import ErrorDialog from '../error_dialog/error_dialog';
import { changeLanguage } from 'i18next';

const SubmitAppDialog: React.FC<SubmitAppDialogProps> = ({ open, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState('');
    const [errorReason, setErrorReason] = useState(false);
    const [errorSubmitApps, setErrorApp] = useState('');
    const { appID } = useParams();
    const dispatch = useDispatch();

    const handleSave = async () => {
        // Check if reason is empty
        if (!reason) {
            // Set the error flag to true and return
            setErrorReason(true);
            return;
        }
    
        setErrorReason(false);
        setLoading(true);
    
        try {
            const configData = {
                reason: reason
            };
    
            // Call the API to save configurations
            const res = await submitAppApi(appID, configData);
   
    
            if (res.data !== null) {
                // If the response status is 200 and there is a success message
                toast.success(res.data);
    
                // Fetch new update changes if needed
                try {
                    const responseUpdate = await getAppOverViewDetails(appID);
                    const slugName = responseUpdate.slug;
                    localStorage.setItem('slug', slugName);
                    dispatch(fetchDataSuccess(responseUpdate));
                } catch (e) {
                    console.error("Error fetching updated details:", e);
                    // Handle error fetching updated details
                }
            } else {
                // If the response status is not 200 or 401 or there's no success message
                console.error("Unexpected or failed response:", res);
                toast.error("Unexpected or failed response");
            }
        } catch (error:any) {
            console.error('Error saving configurations:', error);
    
            // Check if error structure is as expected
            if (error.data && error.data.errors && error.data.errors[0]) {
                console.error('Error saving configurationsaa:', error.data.errors[0].code);
    
                if (error.data.errors[0].code === 1001) {
                    setErrorApp(error.data.errors[0].details);
                    setErrorDialogOpen(true);
                } else {
                    toast.error(error.data.errors[0].message || 'Unknown error occurred');
                }
            } else {
                toast.error('An unexpected error occurred');
            }
        } finally {
            setLoading(false);
        }
    };
    
    

    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    // Function to handle closing the error dialog
    const handleCloseErrorDialog = () => {
        setErrorDialogOpen(false);
    };

    // Function to handle an error
    const handleShowError = (message: string) => {
        setErrorMessage(message); // Set the error message
        setErrorDialogOpen(true); // Open the error dialog
    };

    // Function where an error might occur
    const handleSomethingThatMightFail = () => {
        try {
            // Code that might throw an error
        } catch (error: any) {
            handleShowError('An error occurred: ' + error.message); // Show the error message
        }
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', outline: 'none', borderRadius: '10px' }}>
                    <div style={{ position: 'absolute', top: 0, right: 0, padding: '5px' }}>
                        <img style={{ width: '40px', cursor: 'pointer' }} src={cross} alt="Close Icon" onClick={onClose} />
                    </div>
                    <div style={{ width: '300px', padding: '20px' }}>
                        <TextField
                            label="Reason"
                            autoComplete=""
                            placeholder="Enter reason for submit app"
                            multiline
                            value={reason}
                            onChange={newValue => {
                                // Clear the error flag when user starts typing in the reason field
                                setErrorReason(false);
                                setReason(newValue);
                            }}
                            error={errorReason} // Set the error state of the TextField
                        />
                        {errorReason && <span style={{ color: 'red' }}>Reason cannot be empty</span>}


                    </div>
                    <div style={{ textAlign: 'center' }}>
                        {loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Spinner size='small' />
                            </div>
                        ) : (
                            <button style={{ border: '1px solid grey', borderRadius: '4px', padding: '10px 20px', backgroundColor: 'transparent', color: '#333', cursor: 'pointer', outline: 'none' }} onClick={handleSave}>
                                Submit App
                            </button>
                        )}
                    </div>

                </div>
            </Modal>
            <div>
                <ErrorDialog open={errorDialogOpen} onClose={handleCloseErrorDialog} errorMessage={errorSubmitApps} />
            </div>
        </>
    );
};

// Define PropTypes for the component
interface SubmitAppDialogProps {
    open: boolean;
    onClose: () => void;
}

export default SubmitAppDialog;
